import QueryController from '~/pages/query/query.controller';
import template from './query-block.html';
import './query-block.scss';

export default {
	template,
	controller: QueryController,
	controllerAs: '$ctrl',
	bindings: {
		widgetId: '<',
		isOpen: '=?',
	},
};
